import { createAction } from 'redux-actions';

import {
  LOAD_POSITION_LIST,
  LOAD_POSITION_LIST_SUCCESS,
  LOAD_POSITION_LIST_ERROR,
  ADD_POSITION,
  ADD_POSITION_SUCCESS,
  ADD_POSITION_ERROR,
  UPDATE_POSITION,
  UPDATE_POSITION_SUCCESS,
  UPDATE_POSITION_ERROR,
  DELETE_POSITION,
  DELETE_POSITION_SUCCESS,
  DELETE_POSITION_ERROR,
  RESET_POSITION_LIST,
} from './type';

//Load list position
export const loadPositionListAction = createAction(LOAD_POSITION_LIST);
export const loadPositionListSuccessAction = createAction(
  LOAD_POSITION_LIST_SUCCESS,
);
export const loadPositionListErrorAction = createAction(
  LOAD_POSITION_LIST_ERROR,
);

export const resetPositionListAction = createAction(RESET_POSITION_LIST);

//Add position
export const addPositionAction = createAction(ADD_POSITION);
export const addPositionSuccessAction = createAction(ADD_POSITION_SUCCESS);
export const addPositionErrorAction = createAction(ADD_POSITION_ERROR);

//Update position
export const updatePositionAction = createAction(UPDATE_POSITION);
export const updatePositionSuccessAction = createAction(
  UPDATE_POSITION_SUCCESS,
);
export const updatePositionErrorAction = createAction(UPDATE_POSITION_ERROR);

//Delete position
export const deletePositionAction = createAction(DELETE_POSITION);
export const deletePositionSuccessAction = createAction(
  DELETE_POSITION_SUCCESS,
);
export const deletePositionErrorAction = createAction(DELETE_POSITION_ERROR);
